export const toggleSetItem = <T>(set: Set<T>, item: T): void => {
  setSetItem(set, item, !set.has(item));
};

export const setSetItem = <T>(
  set: Set<T>,
  item: T,
  mustIncluded: boolean,
): void => {
  if (mustIncluded) {
    set.add(item);
  } else {
    set.delete(item);
  }
};
